import { ReachWorkspace, ReachWorkspaceType } from '~app-client/workspaces/types';
import { unassignedWorkspaceId } from '~app-client/workspaces/utils';
import { ClientWorkspace, ClientWorkspaceType } from '~ng-common-lib/workspaces/workspace.type';

export function workspaceClientToworkspaceGenieTransformer(
	workspaces: ReachWorkspace[]
): ClientWorkspace[] {
	const clientWorkspaces = workspaces.map((workspace) => {
		return {
			id: workspace.id,
			name: workspace.name,
			description: workspace.description ?? '',
			type: workspace.type,
			emoji: workspace.emoji ?? '',
			thumbnailUrl: workspace.thumbnailUrl ?? '',
			count: workspace.count,
			integrationId: workspace.integrationId,
			createdAt: workspace.createdAt,
			updatedAt: workspace.updatedAt,
			lastSearchedAt: workspace.lastSearch,
		};
	});

	return clientWorkspaces;
}

export function workspacesToChatSelector(workspaces: ReachWorkspace[]): ClientWorkspace[] {
	const unassigned = workspaces.find((ws) => ws.type === ReachWorkspaceType.UNASSIGNED_NODES);

	return [
		...workspaceClientToworkspaceGenieTransformer(
			workspaces.filter((ws) => ws.type !== ReachWorkspaceType.UNASSIGNED_NODES)
		),
		{
			id: unassignedWorkspaceId,
			name: 'Unassigned',
			description: '',
			type: ClientWorkspaceType.UNASSIGNED_NODES,
			count: unassigned?.count ?? 0,
		},
	];
}
